export { useGetOONConsentQuery } from './useGetOONConsentQuery';
